export interface PsaSqueezeFlagInput {
  squeezeWidth: boolean;
  squeezeHeight: boolean;
  squeezeDepth: boolean;
}

export interface PsaSqueezeInput extends PsaSqueezeFlagInput {
  squeezeWidthPct: number;
  squeezeHeightPct: number;
  squeezeDepthPct: number;
}

export const PSA_SIZE_MODE_DEFAULT = -1;
export const PSA_SIZE_MODE_EXPAND_SQUEEZE = 2;

export const getPsaSqueezeFlag = (squeezeEnabled: boolean) => (squeezeEnabled ? 1 : -1);

export const getPsaSqueezeSizeMode = (squeezeEnabled: boolean) =>
  squeezeEnabled ? PSA_SIZE_MODE_EXPAND_SQUEEZE : PSA_SIZE_MODE_DEFAULT;
